import { render, staticRenderFns } from "./Process.vue?vue&type=template&id=c8c6be16&scoped=true&"
import script from "./Process.vue?vue&type=script&lang=js&"
export * from "./Process.vue?vue&type=script&lang=js&"
import style0 from "./Process.vue?vue&type=style&index=0&id=c8c6be16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c6be16",
  null
  
)

export default component.exports